<div class="threecol"
  fxLayout="column"
  fxLayoutAlign.gt-md="center center">
  <div class="main-col noSlider"
    fxLayout="column"
    fxLayoutGap="20px">

    <h2 class="listHeadline">Registrierung fehlgeschlagen</h2>
    <div>{{message}}</div>

  </div>
</div>